import { getConfigValue } from '@jutro/config';
export const fetchUserInfo = async accessToken => {
  const userInfoEndPoint = `${getConfigValue('JUTRO_AUTH_ISSUER', '')}/v1/userinfo`;
  const userInfo = await fetch(userInfoEndPoint, {
    headers: {
      Authorization: `Bearer ${accessToken}`
    },
    method: 'GET'
  });
  return userInfo.json();
};